import React from 'react';
import './Footer.css';
import {part1, part2} from './elements';

const Footer = () => {
    return (
        <section className="shadow-container">
            <div className="footer-header">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">{part1}</div>
                        <div className="col-md-6">{part2}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Footer;